import { Crop } from '../../Models/Geometry/Crop/Crop';
import { PercentCrop } from '../../Models/Geometry/Crop/PercentCrop';
import { VideoSource } from './VideoSource';

export class LocalVideoSource implements VideoSource {
  public moonNameCrop: Crop = new PercentCrop(19, 72, 62, 10);

  public constructor(private src: string) {}

  public setVideo(video: HTMLVideoElement): void {
    video.src = this.src;
    video.loop = true;
  }
}
